import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Header from './components/Header';
import Footer from './components/Footer';
import ProtectedRoute from './components/ProtectedRoute';
import ProtectedAdminRoute from './components/ProtectedAdminRoute';
import Home from './pages/Home';
import Philosophy from './pages/Philosophy';
import Team from './pages/Team';
import Club from './pages/Club';
import Login from './pages/Login';
import Profile from './pages/Profile';
import AdminUsers from './pages/admin/AdminUsers';
import AdminNews from './pages/admin/AdminNews';
import AdminRecommendations from './pages/admin/AdminRecommendations';
import AdminDocuments from './pages/admin/AdminDocuments';
import AdminAccessLinks from './pages/admin/AdminAccessLinks';
import AdminVkBot from './pages/admin/AdminVkBot';
import News from './pages/News';
import Recommendations from './pages/Recommendations';
import Documents from './pages/Documents';
import Contacts from './pages/Contacts';
import LegalInfo from './pages/LegalInfo';
import Payment from './pages/Payment';
import Redeem from './pages/Redeem';
import './styles/global.css';

// Рендерит Header/Footer только для не-admin страниц
const SiteLayout = ({ children }) => {
  const { pathname } = useLocation();
  if (pathname.startsWith('/admin')) return children;
  return (
    <>
      <Header />
      <main>{children}</main>
      <Footer />
    </>
  );
};

const AppRoutes = () => (
  <SiteLayout>
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/philosophy" element={<Philosophy />} />
      <Route path="/team" element={<Team />} />
      <Route path="/club" element={<Club />} />
      <Route path="/login" element={<Login />} />
      <Route path="/documents" element={<Documents />} />
      <Route path="/contacts" element={<Contacts />} />
      <Route path="/legal-info" element={<LegalInfo />} />
      <Route path="/payment" element={<Payment />} />
      <Route path="/redeem/:token" element={<Redeem />} />
      <Route
        path="/profile"
        element={
          <ProtectedRoute>
            <Profile />
          </ProtectedRoute>
        }
      />
      <Route
        path="/news"
        element={
          <ProtectedRoute>
            <News />
          </ProtectedRoute>
        }
      />
      <Route
        path="/recommendations"
        element={
          <ProtectedRoute>
            <Recommendations />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin"
        element={
          <ProtectedAdminRoute>
            <AdminUsers />
          </ProtectedAdminRoute>
        }
      />
      <Route
        path="/admin/news"
        element={
          <ProtectedAdminRoute>
            <AdminNews />
          </ProtectedAdminRoute>
        }
      />
      <Route
        path="/admin/recommendations"
        element={
          <ProtectedAdminRoute>
            <AdminRecommendations />
          </ProtectedAdminRoute>
        }
      />
      <Route
        path="/admin/documents"
        element={
          <ProtectedAdminRoute>
            <AdminDocuments />
          </ProtectedAdminRoute>
        }
      />
      <Route
        path="/admin/access-links"
        element={
          <ProtectedAdminRoute>
            <AdminAccessLinks />
          </ProtectedAdminRoute>
        }
      />
      <Route
        path="/admin/vk-bot"
        element={
          <ProtectedAdminRoute>
            <AdminVkBot />
          </ProtectedAdminRoute>
        }
      />
    </Routes>
  </SiteLayout>
);

const App = () => (
  <AuthProvider>
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  </AuthProvider>
);

export default App;
